import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LogoutIcon from '@mui/icons-material/Logout';
import {alpha, Box, Typography} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {useAuthMethod, useAuthUser} from 'main/utility/AuthHooks';
import PropTypes from 'prop-types';
import React from 'react';

const UserInfo = ({color = 'text.secondary'}) => {
  const {logout} = useAuthMethod();
  const {user} = useAuthUser();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getUserAvatar = () => {
    if (user.name) {
      return user.name.charAt(0).toUpperCase();
    }
    if (user.email) {
      return user.email.charAt(0).toUpperCase();
    }
  };

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          py: 3,
          px: 4,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          borderTop: (theme) => `1px solid ${theme.palette.divider}`, // Separator line
          backgroundColor: 'rgba(255, 255, 255, 0.02)', // Very subtle lift from Onyx
        }}
        className='user-info-view'
      >
        <Box sx={{py: 0.5}}>
          {user.photoURL ? (
            <Avatar
              sx={{
                height: 36, // Slightly smaller for precision
                width: 36,
                fontSize: 18,
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                fontWeight: 600,
              }}
              src={user.photoURL}
            />
          ) : (
            <Avatar
              sx={{
                height: 36, // Slightly smaller for precision
                width: 36,
                fontSize: 18,
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                fontWeight: 600,
              }}
            >
              {getUserAvatar()}
            </Avatar>
          )}
        </Box>

        <Box sx={{ml: 3, color: color, overflow: 'hidden'}}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 600,
              lineHeight: 1.2,
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              textTransform: 'uppercase', // Matches your button theme
              letterSpacing: '1.5px',
            }}
          >
            {user.name || 'User'}
          </Typography>
          <Typography
            sx={{
              fontSize: 11,
              opacity: 0.7,
              whiteSpace: 'nowrap',
            }}
          >
            System Manager • {user.application}
          </Typography>
        </Box>
        <ExpandMoreIcon sx={{ml: 'auto', fontSize: 18, opacity: 0.5}} />
      </Box>

      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        // Adjusting position to sit elegantly above or next to the UserInfo
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        /* Customizing the Menu Paper */
        PaperProps={{
          sx: {
            mt: -1,
            minWidth: 160,
            backgroundColor: '#232325',
            backgroundImage: 'none',
            border: (theme) => `1px solid ${theme.palette.divider}`,
            borderTop: (theme) => `2px solid ${theme.palette.primary.main}`,
            borderRadius: '4px',
            boxShadow: '0px 12px 30px rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <MenuItem
          onClick={logout}
          sx={{
            py: 2,
            px: 4,
            fontSize: 13,
            fontWeight: 600,
            textTransform: 'uppercase', // Matches UserInfo typography
            letterSpacing: '1px',
            color: 'primary.main', // Yaman Gold
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: (theme) =>
                alpha(theme.palette.primary.main, 0.08),
              color: 'primary.main',
            },
          }}
        >
          <LogoutIcon sx={{fontSize: 18}} />
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserInfo;

UserInfo.propTypes = {
  color: PropTypes.string,
};
